<style lang="less" scoped>
@import "~@/public/less/index.less";
.fan-f-layout{
  width: 100%;
  height: 100% !important;
  overflow: hidden;

  .f-layout{
    width: 100%;
    height: 100%;
    overflow: hidden;

    .f-layout-header{
      .flexRowBetweenCenter();
      background-color: var(--card-bg, #fff);
      padding: 0;
      margin: 0;
      height: auto;
      line-height: inherit;
    }

    .f-layout-content,
    .f-layout-level2{
      width: 100%;
      height: 100%;
      overflow: hidden;

      .head{
        .flexColumn();
        background-color: var(--card-bg, #fff);
        border-bottom: 1px solid var(--border-color, #e8e8e8);
        // padding: 20px;
        height: auto;
        // line-height: inherit;
        // box-shadow: 0 2px 6px rgba(0,21,41,.05);
        // z-index: 2;
        // padding:20px;

        .breadcrumb{
          // margin: 20px;
        }
      }
      

      .main{
        width: 100%;
        height: 100%;
        overflow: hidden auto;
        // border-radius: 0 0 15px 15px;

        .mainBody{
          width: 100%;
          height: 100%;
          overflow-x: hidden;
          overflow-y: auto;
          display: flex;
          flex-direction: row;
          align-items: stretch;

          .menus{
            min-width: 160px;
            max-width: 240px;
            height: 100%;
            margin: 20px 0 20px 20px;
            padding: 0;
            box-sizing: border-box;
            border: 1px solid var(--border-color, #e8e8e8);
            border-radius: 4px;
            background: var(--menu-bg, #fff) !important;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            
            > div {
              height: 100% !important;
              background: var(--menu-bg, #fff) !important;
              flex: 1;
            }
          }

          .mainContent{
            flex: 1;
            height: 100%;
            // margin: 20px 0 20px 0;
            display: flex;
            flex-direction: column;

            .subHead{
              .flexRowBetweenCenter();
              padding: 20px;
              background-color: var(--card-bg, #fff);
              border-bottom: 1px solid var(--border-color, #e8e8e8);
              // margin: 0 20px 20px 20px;
              line-height: inherit;

              .subHeadLeft{
                .flexRowLeftCenter();
                flex: 5;
              }
              .subHeadRight{
                .flexRowRightCenter();
                flex: 1;
              }
            }

            &.full-width .subHead{
              // margin-left: 20px;
              // margin-right: 20px;
            }

            .subHead2{
              width: 100%;

              .subHeadtop{
                padding: 20px;
                background-color: var(--card-bg, #fff);
                // margin: 20px 20px 0 20px;
                line-height: inherit;
                width: 100%;
              }
              .subHeadbom{
                width: 100%;
                flex-wrap: wrap;
                padding: 20px;
                background-color: var(--card-bg, #fff);
                // margin: 20px 20px 0 20px;
                line-height: inherit;
              }
            }

            &.full-width .subHead2 .subHeadtop,
            &.full-width .subHead2 .subHeadbom{
              // margin-left: 20px;
              // margin-right: 20px;
            }

            .content{
              .flexRow();
              width: 100%;

              .contentmain{
                flex: 3;
                // margin: 0 20px 20px 20px;
              }
              .contentBody{
                flex: 3;
                // margin: 0 20px 20px 20px;
                >div{
                  padding: 20px;
                  // background-color: var(--card-bg, #fff);
                }
              }
              .minor{
                flex: 1;
                // margin: 0 20px 20px 20px;
                >div{
                  padding: 20px;
                  background-color: var(--card-bg, #fff);
                }
              }
            }

            &.full-width .content .contentmain,
            &.full-width .content .contentBody{
              // margin-left: 20px;
              // margin-right: 20px;
            }
          }
        }
      }
    }

    .f-layout-footer{
      .flexRowBetweenCenter();
      z-index: 998;
      background-color: var(--card-bg, #fff);
      padding: 0 20px;
      margin: 0;
      height: 48px;
      line-height: inherit;
      box-shadow: -2px 0 6px rgba(0,21,41,.2);
    }
  }
}
</style>

<style lang="less">
@import "~@/public/less/index.less";

/* 菜单样式 */
.fan-f-layout .menus .arco-menu,
.fan-f-layout .menus .arco-menu-light {
  background: var(--menu-bg, transparent) !important;
  color: var(--menu-text, #333) !important;
}
.fan-f-layout .menus .arco-menu-item,
.fan-f-layout .menus .arco-menu-pop-header {
  background: var(--menu-bg, transparent) !important;
  color: var(--menu-text, #333) !important;
}
.fan-f-layout .menus .arco-menu-item.arco-menu-selected {
  background: var(--menu-selected-bg, #e6f7ff) !important;
  color: var(--menu-selected-text, #1890ff) !important;
}
.fan-f-layout .menus .arco-menu-item:hover {
  background: #f5f7fa !important;
  color: #1890ff !important;
}

#drawer{
  .arco-drawer{
    .arco-drawer-content{
      .arco-drawer-header{
        height: 48px;
        line-height: 48px;
      }
      .arco-drawer-body{
        height: 100%;
        padding: 48px 0;
        overflow: hidden;

        .drawer-top, .drawer-bottom{
          .flexRowBetweenCenter();
          position: absolute;
          width: 100%;
          height: 48px;
          background-color: var(--card-bg, #fff);
          left: 0;
        }
        .drawer-top{
          top: 0;
          border-bottom: 1px solid var(--border-color, #e8e8e8);
          padding: 0 20px;
        }
        .drawer-body{
          height: 100%;
          padding: 10px 20px;
          overflow-x: hidden;
          overflow-y: auto;
        }
        .drawer-bottom{
          bottom: 0;
          border-top: 1px solid var(--border-color, #e8e8e8);
          padding: 0 20px;
        }
      }
    }
  }
}

.fan-curd-modal{
  padding: 0px;
}
</style>



<template>
  <div class="fan fan-component fan-f-layout">
    <a-layout class="f-layout">
      <a-layout-content class="f-layout-content">
        <a-layout class="f-layout-level2">
          <a-layout-header class="head" v-if="$slots.breadcrumb || $slots.head">
            <div v-show="$slots.breadcrumb" class="breadcrumb">
              <a-breadcrumb separator=">"><a-breadcrumb-item v-for="(item, index) in router.info.breadcrumb" :key="index">
                    <router-link :to="item.url">
                      <component :is="'icon-' + (item.icon || 'appstore')" />
                      <span>{{item.name}}</span>
                    </router-link>
                  </a-breadcrumb-item>
              </a-breadcrumb>
            </div>
            <slot name="head"></slot>
          </a-layout-header>
          <a-layout-content class="main">
            <div class="mainBody">
              <!-- 子菜单 -->
              <div class="menus" v-if="$slots.menus">
                <slot name="menus"></slot>
              </div>
              <div class="mainContent" :class="{ 'full-width': !$slots.menus }">
                <div class="subHead" v-if="$slots.subHeadLeft || $slots.subHeadRight">
                  <div class="subHeadLeft" v-if="$slots.subHeadLeft">
                    <slot name="subHeadLeft"></slot>
                  </div>
                  <div v-else></div>
                  <div class="subHeadRight" v-if="$slots.subHeadRight">
                    <slot name="subHeadRight"></slot>
                  </div>
                </div>
                <div class="subHead2" v-if="$slots.subHeadtop || $slots.subHeadbom">
                  <div class="subHeadtop" v-if="$slots.subHeadtop">
                    <slot name="subHeadtop"></slot>
                  </div>
                  <div v-else></div>
                  <div class="subHeadbom" v-if="$slots.subHeadbom">
                    <slot name="subHeadbom"></slot>
                  </div>
                </div>
                <div class="content" v-if="$slots.body || $slots.minor || $slots.main">
                  <div class="contentmain" v-if="$slots.main">
                    <div>
                      <slot name="main"></slot>
                    </div>
                  </div>
                  <div class="contentBody" v-if="$slots.body">
                    <div>
                      <slot name="body"></slot>
                    </div>
                  </div>
                  <div class="minor" v-if="$slots.minor">
                    <div>
                      <slot name="minor"></slot>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </a-layout-content>
        </a-layout>
      </a-layout-content>
      <a-layout-footer class="f-layout-footer" v-if="$slots.footLeft || $slots.footRight">
        <div class="footLeft" v-if="$slots.footLeft">
          <slot name="footLeft"></slot>
        </div>
        <div v-else></div>
        <div class="footRight" v-if="$slots.footRight">
          <slot name="footRight"></slot>
        </div>
      </a-layout-footer>
    </a-layout>

    <!-- 全局查看新增编辑窗口 (Drawer) -->
    <div id="drawer" v-if="page.drawer">
      <a-drawer
        :container="'#drawer'"
        :width="page.drawer.width"
        :visible="page.drawer.visible"
        :unmountOnClose="true"
        :title="page.drawer.title"
        @cancel="bindCloseDrawer"
        >
        <div class="drawer-body">
          <f-detail ref="fdetail"
                    v-if="page.drawer.visible && page.drawer.title==='详情'"
                    :superApi="superApi"
                    :superData="page.drawer.data"
                    @emitOpenDrawer="bindOpenDrawer"
                    @emitCloseDrawer="bindCloseDrawer"
                    @emitReloadData="bindReloadData" />
          <f-form ref="fform"
                  v-else-if="page.drawer.visible"
                  :superApi="superApi"
                  :superData="page.drawer.data"
                  @emitOpenDrawer="bindOpenDrawer"
                  @emitCloseDrawer="bindCloseDrawer"
                  @emitReloadData="bindReloadData" />
        </div>
        <template #footer>
          <div style="display:flex; justify-content:space-between; align-items:center;">
            <a-tooltip content="打印" v-if="page.drawer.title==='详情'" >
              <a-button @click="$refs.fdetail.actionDetailPrint()"><icon-printer />打印</a-button>
            </a-tooltip>
            <a-tooltip content="提交" v-if="page.drawer.title!=='详情'" >
              <a-button type="primary" status="success" @click="$refs.fform.actionFormSubmit()"><icon-check />提交</a-button>
            </a-tooltip>
          </div>
        </template>
      </a-drawer>
    </div>

    <!-- 全局弹窗式新增编辑查看窗口 (Modal) -->
    <div id="modal" v-if="page.modal">
      <a-modal
          v-model:visible="page.modal.visible"
          :title="page.modal.title"
          :width="page.modal.width"
          :align-center="true"
          :unmountOnClose="true"
          @ok="bindCloseModal"
      >
        <div v-if="page.modal.title==='详情'">
          <f-detail ref="mdetail"
                    :superApi="superApi"
                    :superData="page.modal.data"
                    @emitOpenDrawer="bindOpenModal"
                    @emitCloseDrawer="bindCloseModal"
                    @emitReloadData="bindReloadData" />
        </div>
        <div v-else-if="page.modal.title==='二维码'" style="text-align:center;">
          <div style="text-align:center;font-size: 20px;font-weight: bold;">{{page.modal.data.name}}</div>
        </div>
        <div v-else>
          <f-form ref="mform"
                  :superApi="superApi"
                  :superData="page.modal.data"
                  @emitOpenDrawer="bindOpenModal"
                  @emitCloseDrawer="bindCloseModal"
                  @emitReloadData="bindReloadData" />
        </div>
        <template #footer>
          <a-button v-if="page.modal.title==='详情'" @click="$refs.mdetail.actionDetailPrint()"><icon-printer /></a-button>
          <a-button v-if="page.modal.title!=='详情' && page.modal.title!=='二维码'" type="primary" status="success" @click="$refs.mform.actionFormSubmit()"><icon-check /></a-button>
          <a-button v-if="page.modal.title==='二维码'" type="primary" @click="page.modal.visible = false"><icon-close />关闭</a-button>
        </template>
      </a-modal>
    </div>
  </div>
</template>

<script>
  import { IconClose, IconPrinter, IconCheck } from '@arco-design/web-vue/es/icon'

  export default {
    name: 'FLayout',
    props: {
      superApi: String,
      superPage: Object
    },
    created() {
      this.page = this.$fan.utils.parse(this.def.page)
      this.data = this.$fan.utils.parse(this.def.data)
    },
    mounted() {},
    computed: {
      router() {
        const r = this.$store.state.routers[this.$route.path]
        if (r) return r
        // 基础路由（如 /help）未注册进 routers 状态表时会是 undefined，
        // 这里兜底，避免模板读 router.info.breadcrumb 时报错
        if (this.$route.path === '/help') {
          return { info: { breadcrumb: [{ name: '帮助中心', url: '/help', icon: 'question-circle' }] } }
        }
        return { info: { breadcrumb: [] } }
      }
    },
    data() {
      return {
        page: {}, data: {},
        menuCollapsed: false,
        def: {
          page: {
            drawer: {
              width: '900px',
              visible: false,
              title: '详情',
              data: Object
            },
            modal: {
              width: '900px',
              visible: false,
              title: '详情',
              data: Object
            }
          },
          data: {}
        }
      }
    },
    methods: {
      async bindReloadData() {
        await this.bindCloseDrawer()
        await this.bindCloseModal()
        this.$emit("reloadData")
      },
      // 控制drawer
      bindOpenCurd(title='详情', data={record:{}}) {   
          const cols = this.$store.state.page?.columns || {}
          let colCount = Object.keys(cols).filter(k => {
            const c = cols[k]
            // 只排除明确在 add/edit 隐藏的列，hidden:['list'] 的要计入
            return c && !(Array.isArray(c.hidden) && (c.hidden.includes('add') || c.hidden.includes('edit')))
          }).length
          if (colCount === 0) {
            const tcs = this.$store.state.page?.tableColumns || []
            colCount = tcs.filter(c => {
              return c && c.dataIndex && !(Array.isArray(c.hidden) && (c.hidden.includes('add') || c.hidden.includes('edit')))
            }).length
          }
          const w = colCount > 8 ? '1000px' : '550px'
          this.page.drawer = {
            ...this.page.drawer,
            title,
            data: data.record,
            width: w
          }
          this.$nextTick(() => {
            this.page.drawer.visible = true
          })
      },
      bindOpenDrawer(e) {
        this.page.drawer.visible = true
      },
      async bindCloseDrawer(e) {
        this.page.drawer.visible = false
      },
      // 控制modal
      bindOpenCurdModal(title='详情', data={record:{}}) {
        if(title == '二维码'){
          this.page.modal.width = '340px'
        } else {
          // 根据字段数自动调整弹窗宽度
          const cols = this.$store.state.page?.columns || {}
          const colCount = Object.keys(cols).filter(k => {
            const c = cols[k]
            return c && !c.hidden && !(Array.isArray(c.hidden) && (c.hidden.includes('add') || c.hidden.includes('edit')))
          }).length
          if (colCount <= 8) {
            this.page.modal.width = '520px'
          } else {
            this.page.modal.width = '900px'
          }
        }
        this.page.modal.title = title
        this.page.modal.data = data.record
        this.bindOpenModal()
      },
      bindOpenModal(e) {
        this.page.modal.visible = true
      },
      async bindCloseModal(e) {
        this.page.modal.visible = false
      },
      
    }
  }
</script>
